import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ActivityRows from '../Home/components/ActivityRows';
import RedPacketLogs from './RedPacketLogs';
import '../Home/Home.css';
import './Activity.css';

const FILTERS = ['all', 'purchases', 'deposits', 'withdraw', 'cashback', 'redPacket'] as const;

type Filter = (typeof FILTERS)[number];

function ActivityPage() {
    const { t } = useTranslation('activity');
    const [filter, setFilter] = useState<Filter>('all');

    return (
        <div className="activity-page">
            <div className="page-heading">
                <div>
                    <h1>{t('heading.title')}</h1>
                    <p>{t('heading.subtitle')}</p>
                </div>
            </div>

            <div className="activity-tabs" role="tablist" aria-label={t('filters.a11y')}>
                {FILTERS.map((item) => (
                    <button
                        key={item}
                        type="button"
                        className={`activity-tab${filter === item ? ' active' : ''}`}
                        aria-pressed={filter === item}
                        onClick={() => setFilter(item)}
                    >
                        {t(`filters.${item}`)}
                    </button>
                ))}
            </div>

            <section className="panel">
                {filter === 'redPacket' ? <RedPacketLogs /> : <ActivityRows filter={filter} />}
            </section>
        </div>
    );
}

export default ActivityPage;
